export const productPrices = {
  productPrices: {
    crossedPrice: {
      label: 'Instead of',
    },
  },
};
